export const imageSliders = [
    {
        url: 'https://salvagemeubcket.s3.amazonaws.com/landingPage/rocket-compressed.jpg',
        title: 'Launching Soon',
        description: "SalvageMe"
    },
    {
        url: 'https://salvagemeubcket.s3.amazonaws.com/landingPage/donate2-compressed.jpg',
        title: "Donate your books to us",
        description: "let's put your old books to use"
    },
    {
        url: 'https://salvagemeubcket.s3.us-east-1.amazonaws.com/landingPage/disburse-compressed.jpg',
        title: 'We donate your books',
        description: "to people who need them"
    }
]

export const books = [
    {
        id: 1,
        imageUrl: '/images/books/b1.jpg',
        title: 'Core Maths',
        level: 'SHS',
        author: "Aki Ola",
        category: "maths",
        description: "book desc here"
    },
    {
        id: 2,
        imageUrl: '/images/books/b2.jpeg',
        title: "Core Maths",
        level: 'JHS',
        author: "Aki Ola",
        category: "maths",
        description: "book desc here"
    },
    {
        id: 3,
        imageUrl: '/images/books/b3.jpg',
        title: 'Integrated Science',
        level: 'SHS',
        author: "Aki Ola",
        category: "science",
        description: "book desc here"
    },
    {
        id: 4,
        imageUrl: '/images/books/b4.png',
        title: 'Practical Chemistry',
        level: 'SHS',
        author: "Aki Ola",
        category: "chemistry",
        description: "book desc here"
    },
    {
        id: 5,
        imageUrl: '/images/books/b5.jpg',
        title: 'Elective Maths',
        level: 'SHS',
        author: "Aki Ola",
        category: "maths",
        description: "book desc here"
    },
    {
        id: 6,
        imageUrl: '/images/books/b6.jpeg',
        title: 'Graded Reader',
        level: 'Primary',
        author: "Aki Ola",
        category: "english",
        description: "book desc here"
    },
    {
        id: 7,
        imageUrl: '/images/books/b7.jpg',
        title: 'The monkey prince',
        level: 'Primary',
        author: "Moran",
        category: "english",
        description: "book desc here"
    },
    {
        id: 8,
        imageUrl: '/images/books/b8.jpg',
        title: 'Biology',
        level: 'SHS',
        author: "Aki Ola",
        category: "biology",
        description: "book desc here"
    },
    {
        id: 9,
        imageUrl: '/images/books/b9.jpg',
        title: 'English',
        level: 'SHS',
        author: "Aki Ola",
        category: "english",
        description: "book desc here"
    },
    {
        id: 10,
        imageUrl: '/images/books/b10.jpg',
        title: 'Social studies',
        level: 'Primary',
        author: "Sally",
        category: "social",
        description: "book desc here"
    },
]